import {
	APPROVE_ARTICLES_GET_ARTICLES,
	APPROVE_ARTICLES_GET_ARTICLES_FAILURE,
	APPROVE_ARTICLES_GET_ARTICLES_SUCCESS,
	APPROVE_ARTICLES_REMOVE_ARTICLES,
	APPROVE_ARTICLES_REMOVE_ARTICLES_FAILURE,
	APPROVE_ARTICLES_REMOVE_ARTICLES_SUCCESS,
	APPROVE_ARTICLES_PROPS_CHANGED,
} from "./actions";
import {find, removeElem} from "../../../utility/functions";

const initialState = {
	loading: false,
	articles: null,
	article: null,
	index: null,
	inRemoveMode: false,
	removing: false,
	pagination: null,
	clickedArticleId: null,
};

export const approveArticlesReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case APPROVE_ARTICLES_GET_ARTICLES:
			return {
				...state,
				loading: true,
			};
		case APPROVE_ARTICLES_GET_ARTICLES_SUCCESS:
			return {
				...state,
				articles: action.articles,
				pagination: action.pagination,
				loading: false,
			};
		case APPROVE_ARTICLES_GET_ARTICLES_FAILURE:
			return {
				...state,
				loading: false,
			};
		case APPROVE_ARTICLES_REMOVE_ARTICLES:
			return {
				...state,
				removing: true,
			};
		case APPROVE_ARTICLES_REMOVE_ARTICLES_SUCCESS:
			return {
				...state,
				articles: removeElem(state.articles, 'id', find(action.article, 'id')),
				removing: false,
				inRemoveMode: false,
				article: null,
				inDex: null,
			};
		case APPROVE_ARTICLES_REMOVE_ARTICLES_FAILURE:
			return {
				...state,
				removing: false,
				inRemoveMode: false,
			};
		case APPROVE_ARTICLES_PROPS_CHANGED:
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};